import { useEffect, useState } from 'react';
import request from '../../../../../lib/request';
import Daily from './daily';
import Weekly from './weekly';

const Detail = ({
  dialogRef,
  closeDialog,
  challenge,
  refresh,
  isDetailDialogOpen,
  status,
}) => {
  const [routines, setRoutines] = useState([]);

  useEffect(() => {
    if (isDetailDialogOpen) {
      getRoutines();
    }
  }, [isDetailDialogOpen]);

  const getRoutines = async () => {
    try {
      const { result } = await request.get(
        `/user/challenge/${challenge.challengeId}/routines${
          challenge.category === 'CUSTOM'
            ? `?category=CUSTOM&targetId=${challenge.id}`
            : ''
        }`
      );
      if (result?.length > 0) {
        setRoutines(result);
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <dialog
        ref={dialogRef}
        className='w-full h-full max-w-lg max-h-full p-4'
      >
        <div className='flex items-center gap-4 mb-4'>
          <button
            className='text-2xl'
            onClick={closeDialog}
          >
            ‹
          </button>
          <div className='text-xl font-bold'>{challenge.title}</div>
        </div>
        <div className='space-y-4'>
          {challenge.type === 'DAILY' && (
            <Daily
              challenge={challenge}
              closeDetailDialog={closeDialog}
              refresh={refresh}
              routines={routines}
              status={status}
            />
          )}
          {challenge.type === 'WEEKLY' && (
            <Weekly
              challenge={challenge}
              closeDetailDialog={closeDialog}
              refresh={refresh}
            />
          )}
        </div>
      </dialog>
    </>
  );
};

export default Detail;
